import React, { useState } from "react";
import moment from "moment";

function AppointmentForm({
  appointmentTypes,
  appointmentType,
  setAppointmentType,
  selectedSlot,
  selectedDate,
  selectedStartTime,
  selectedEndTime,
  handleManualSlotChange
}) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName:"",
    mobilePhone: "",
    email: "",
    areaOfConcern: "",
    consent: false
  });

  const SaveAppointment = async (e) => {
    e.preventDefault();

    const appointmentData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobilePhone: formData.mobilePhone,
      email: formData.email,
      areaOfConcern: formData.areaOfConcern,
      appointmentType: appointmentType,
      appointmentDate: selectedDate,
      startTime: selectedStartTime,
      endTime: selectedEndTime,
      consent: false
    };

    console.log("Appointment Data:", appointmentData);

    try {
      const response = await fetch(
        "https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/createappointment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(appointmentData)
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save appointment");
      }

      const result = await response.json();

      console.log("Appointment saved:", result);

      alert("Appointment booked successfully!");
    } catch (error) {
      console.error("Error saving appointment:", error);
      alert("Unable to book appointment.");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  return (
    <form className="form" onSubmit={SaveAppointment}>
      {selectedSlot && (
        <div className="info-note">
          <strong>Selected Slot : </strong>
          {moment(selectedSlot.start).format("MMM D, h:mm A")} –{" "}
          {moment(selectedSlot.end).format("MMM D, h:mm A")}
        </div>
      )}

      {/* Patient Info Section */}
      <div className="form-section">
        <h3 className="section-label-small">Patient Information</h3>

        <div className="form-group spaced">
          <label className="form-label">First Name</label>
          <input
            type="text"
            name="firstName"
            className="form-control"
            placeholder="first name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group spaced">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            name="lastName"
            className="form-control"
            placeholder="last name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group spaced">
          <label className="form-label">Mobile Phone</label>
          <input
            type="text"
            name="mobilePhone"
            className="form-control"
            placeholder="mobile"
            value={formData.mobilePhone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group spaced">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      {/* Appointment Details */}
      <div className="form-section mt-3">
        <div className="form-group spaced">
          <label className="form-label">Area of Concern</label>
          <input
            type="text"
            name="areaOfConcern"
            className="form-control"
            placeholder="Describe briefly"
            value={formData.areaOfConcern}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group spaced">
          <label className="form-label">Appointment Type</label>

          <select
            className="form-control  form-select"
            value={appointmentType}
            onChange={(e) => setAppointmentType(e.target.value)}
            required
          >
            <option value="">Select type</option>

            {appointmentTypes.map((type, idx) => (
              <option key={idx} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="row g-2">
          <div className="col-md-4">
            <div className="form-group spaced">
              <label className="form-label">Preferred Date</label>

              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) =>
                  handleManualSlotChange(
                    e.target.value,
                    selectedStartTime,
                    selectedEndTime
                  )
                }
                required
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group spaced">
              <label className="form-label">Start Time</label>

              <input
                type="time"
                className="form-control"
                value={selectedStartTime}
                onChange={(e) =>
                  handleManualSlotChange(
                    selectedDate,
                    e.target.value,
                    selectedEndTime
                  )
                }
                required
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group spaced">
              <label className="form-label">End Time</label>

              <input
                type="time"
                className="form-control"
                value={selectedEndTime}
                onChange={(e) =>
                  handleManualSlotChange(
                    selectedDate,
                    selectedStartTime,
                    e.target.value
                  )
                }
                required
              />
            </div>
          </div>
        </div>
      </div>

      {/* Consent */}
      {/* <div className="form-group mb-3 mt-3">
        <label className="flex-center gap-8">
          <input
            type="checkbox"
            name="consent"
            checked={formData.consent}
            onChange={handleChange}
            required
          />

          I consent to receive text messages
        </label>
      </div> */}

      {/* Submit */}
      <button type="submit" className="btn btn-success w-100">
        Book Appointment
      </button>
    </form>
  );
}

export default AppointmentForm;